import { z } from 'zod';
import { countryCodeSchema } from './countries';

/** GET /api/health */
export const healthResponseSchema = z.object({
  ok: z.literal(true),
  env: z.string(),
  version: z.string(),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;

/** Error envelope returned by every non-2xx worker response. */
export const apiErrorSchema = z.object({
  error: z.object({ code: z.string(), message: z.string() }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

/** GET /api/geo: the visitor's country from Cloudflare, or null (local dev, Tor, unknown). Prefills sign-up. */
export const geoResponseSchema = z.object({ country: countryCodeSchema.nullable() });
export type GeoResponse = z.infer<typeof geoResponseSchema>;
